import * as ABCya from '@abcya/abcya_phaser';
import gameData from '../../gameData';
import sKey from '../../SoundAssetKeys';
import { simpleClickAnimation } from './makeDonutStart';

export async function createChooseFrost(scene)
{
    //gameData.makeData.index = 2;
    //console.log("create frost")
    if(!gameData.makeData.frostingUI)
    {
        scene.makeDonut.setAlpha(1);
        scene.backBut.setAlpha(1); 
        //console.log("create")
        centerDonut(scene);
        return frostTween();
        
    }
    else
    {
        frostTween();
        //scene.makeDonut.setAlpha(1);
        scene.backBut.setAlpha(1);
        //console.log("reappear")
        for(let each in gameData.makeData.frostingUI)
        {
            gameData.makeData.frostingUI[each].setAlpha(1);
        }
    }
}

export function cleanUpFrost(scene)
{
    for(let each in gameData.makeData.frostingUI)
    {
        gameData.makeData.frostingUI[each].destroy();
    }

    gameData.makeData.frostingUI = "";
    //scene.backBut.setAlpha(0);
    //scene.makeDonut.setAlpha(0);
    //scene.selector2.setAlpha(1);
}

function centerDonut(scene)
{
    const donut = scene.makeDonut;
    const shape = gameData.makeData.selected.shape;
    const frameNoColor = `Donuts and Sprinkles/Donut_${shape}_`;
    //console.log(scene.makeDonut.alpha);

    scene.makeDonut.setFrame(`Donuts and Sprinkles/Donut_${shape}_Plain`);

    if(scene.makeDonut.alpha <= 0)scene.makeDonut.setAlpha(1);
    //if(scene.backBut.alpha <= 0)scene.backBut.setAlpha(1);

    //scene.questionText.setPosition(512,116);
    //scene.questionText.text = "Pick a frosting color:";

    const buttons = displayPoints(donut,createCirclePoints(donut));

    for(let each in buttons)
    {
        buttons[each].setInteractive();

        buttons[each].on("pointerdown",()=>{
            simpleClickAnimation(buttons[each],false);
            donut.setFrame(frameNoColor+buttons[each].donutColor);
        });

    }

    gameData.makeData.frostingUI = buttons;
}

export function createCirclePoints(gameObject,dist = 25,pointWidth = 53)
{
    //create points using a circle, and each point being 30 degrees away from the next

    /*  Some math stuff here, basically, with the exception of the 4 corner points,
        every point is the same angle, it will always use the same triangle
        to find the point where the color dot goes.  
        The corners are a different deal, they are isosceles right triangles
        as such the placement for them is a different formula */

    const objRadius = (gameObject.width * gameObject.scale)*.5 + dist + pointWidth;
    const cornerDist = objRadius / Math.sqrt(2);//formula for isoceles right triangle
    const returnObj = {};

    const shortDist = Math.sin(15* Math.PI / 180)*objRadius;//formula for right triangle, converison from radians
    const longDist = Math.cos(15* Math.PI / 180)*objRadius;

    returnObj.top1 = {x:gameObject.x - shortDist,y:gameObject.y - longDist};
    returnObj.top2 = {x:gameObject.x + shortDist,y:gameObject.y - longDist};

    returnObj.topRight = {x:gameObject.x+cornerDist,y:gameObject.y - cornerDist};

    returnObj.right1 = {x:gameObject.x + longDist,y:gameObject.y - shortDist};
    returnObj.right2 = {x:gameObject.x + longDist,y:gameObject.y + shortDist};

    returnObj.bottomRight = {x:gameObject.x+cornerDist,y:gameObject.y + cornerDist};

    returnObj.bottom1 = {x:gameObject.x + shortDist,y:gameObject.y + longDist};
    returnObj.bottom2 = {x:gameObject.x - shortDist,y:gameObject.y + longDist};

    returnObj.bottomleft = {x:gameObject.x-cornerDist,y:gameObject.y + cornerDist};

    returnObj.left1 = {x:gameObject.x - longDist,y:gameObject.y + shortDist};
    returnObj.left2 = {x:gameObject.x - longDist,y:gameObject.y - shortDist};
    
    returnObj.topLeft = {x:gameObject.x-cornerDist,y:gameObject.y - cornerDist};

    return returnObj;
}

export function displayPoints(gameObject,pointsObj)
{
    const scene = gameObject.scene;
    const colors = ["Black","Pink","Purple","Lavender","LightBlue","Blue","Teal","Green","Yellow","Orange","Red","Brown"];
    let counter = 0;
    const colorButs = [];

    if(gameObject.frame.name.includes("Triangle"))
    {
        for(let x in pointsObj)
        {
            pointsObj[x].y += 20;
        }
    }
    else if(gameObject.frame.name.includes("Heart"))
    {
        for(let x in pointsObj)
        {
            pointsObj[x].y -= 14;
        }
    }
    else if(gameObject.frame.name.includes("Star"))
    {
        for(let x in pointsObj)
        {
            pointsObj[x].y += 10;
        }
    }

    for(let x in pointsObj)
    {
        const but = ABCya.Images.addImage(pointsObj[x].x,pointsObj[x].y,`Make Your Donut/Btn_${colors[counter]}`,scene).setDepth(3).setAlpha(0);
        but.donutColor = colors[counter];
        colorButs.push(but);
        counter++;
    }

    return colorButs;
}

function frostTween()
{
    return new Promise(resolve => {
        const scene = gameData.makeData.frostingUI[0].scene;
        scene.custSound.playSoundCustom(sKey._colors_tween_in);
        for(let each in gameData.makeData.frostingUI)
        {   
            let button = gameData.makeData.frostingUI[each];
            button.disableInteractive();
            let tween = ABCya.Tweens.addTween(button,600,{x:{start:512, to:button.x}, y:{start:405, to: button.y}, alpha:{start:0,to:1}, delay:each*50});
            tween.on('complete',()=>{
                button.setInteractive();
                if(Number(each) === gameData.makeData.frostingUI.length-1)
                {
                    resolve();
                }
            });
            //gameData.makeData.frostingUI[each].setAlpha(1);
        }
    });
}

export function frostTweenOut(scene,back = false)
{
    return new Promise(resolve => {
        let time = 600;
        const scene = gameData.makeData.frostingUI[0].scene;
        scene.custSound.playSoundCustom(sKey._colors_tween_out);
        if(back)ABCya.Tweens.addTween(scene.makeDonut,time,{alpha:0});
        for(let each in gameData.makeData.frostingUI)
        {  
            let button = gameData.makeData.frostingUI[each];

            button.disableInteractive();
            
            ABCya.Tweens.addTween(button,time,{x:512, y:405, delay:each*50, yoyo: true});
            const tween = ABCya.Tweens.addTween(button,time,{alpha:0, delay:each*50},Phaser.Math.Easing.Linear,()=>{
                if(Number(each) === (gameData.makeData.frostingUI.length - 1))
                {
                    resolve();
                }
            });
        }
    });
}